import classnames from 'classnames';

import AirplaneSVG from '@/svg/icons/airplane.svg';
import APIsSVG from '@/svg/icons/apis.svg';
import ApolloSVG from '@/svg/icons/apollo.svg';
import ArchiveSVG from '@/svg/icons/archive.svg';
import AssetSVG from '@/svg/icons/asset.svg';
import BookSVG from '@/svg/icons/book.svg';
import BookmarkSVG from '@/svg/icons/bookmark.svg';
import BuildingsSVG from '@/svg/icons/buildings.svg';
import CalendarSVG from '@/svg/icons/calendar.svg';
import CartSVG from '@/svg/icons/cart.svg';
import ChatSVG from '@/svg/icons/chat.svg';
import CloudUploadSVG from '@/svg/icons/cloud_upload.svg';
import CodeSVG from '@/svg/icons/code.svg';
import ConnectSVG from '@/svg/icons/connect.svg';
import ContentSVG from '@/svg/icons/content.svg';
import EditSVG from '@/svg/icons/edit.svg';
import FingerprintSVG from '@/svg/icons/fingerprint.svg';
import GameControllerSVG from '@/svg/icons/game_controller.svg';
import GatsbySVG from '@/svg/icons/gatsby.svg';
import GlobeSVG from '@/svg/icons/globe.svg';
import GoingUpSVG from '@/svg/icons/going_up.svg';
import GCMSSVG from '@/svg/icons/graphcms.svg';
import GraphQLSVG from '@/svg/icons/graphql.svg';
import GridSVG from '@/svg/icons/grid.svg';
import GridsomeSVG from '@/svg/icons/gridsome.svg';
import GrowthSVG from '@/svg/icons/growth.svg';
import HugoSVG from '@/svg/icons/hugo.svg';
import IncompleteGridSVG from '@/svg/icons/incomplete-grid.svg';
import JekyllSVG from '@/svg/icons/jekyll.svg';
import LaptopSVG from '@/svg/icons/laptop.svg';
import LayersSVG from '@/svg/icons/layers.svg';
import ListSVG from '@/svg/icons/list.svg';
import LocalizationSVG from '@/svg/icons/localization.svg';
import MoneySVG from '@/svg/icons/money.svg';
import NextSVG from '@/svg/icons/next-dot-js.svg';
import NuxtSVG from '@/svg/icons/nuxt-dot-js.svg';
import PadlockSVG from '@/svg/icons/padlock.svg';
import OmnichannelSVG from '@/svg/icons/omnichannel.svg';
import PersonSVG from '@/svg/icons/person.svg';
import PhoneSVG from '@/svg/icons/phone.svg';
import PrivacySVG from '@/svg/icons/privacy.svg';
import QuestionSVG from '@/svg/icons/question.svg';
import ReactSVG from '@/svg/icons/react-dot-js.svg';
import ResizeSVG from '@/svg/icons/resize.svg';
import ResizeAllSVG from '@/svg/icons/resize_all.svg';
import ShareSVG from '@/svg/icons/share.svg';
import SvelteSVG from '@/svg/icons/svelte.svg';
import SheetsSVG from '@/svg/icons/sheets.svg';
import ShoppingSVG from '@/svg/icons/shopping.svg';
import SitepointSVG from '@/svg/icons/sitepoint.svg';
import SlackSVG from '@/svg/icons/slack.svg';
import SpeechSVG from '@/svg/icons/speech.svg';
import SquarePlusSVG from '@/svg/icons/square_plus.svg';
import SquareWrenchSVG from '@/svg/icons/square_wrench.svg';
import StagingSVG from '@/svg/icons/staging.svg';
import StarSVG from '@/svg/icons/star.svg';
import StarOutlineSVG from '@/svg/icons/star_outline.svg';
import TextboxSVG from '@/svg/icons/textbox.svg';
import TuningSVG from '@/svg/icons/tuning.svg';
import TypingCursorSVG from '@/svg/icons/typing_cursor.svg';
import UserShieldSVG from '@/svg/icons/user_shield.svg';
import VersioningSVG from '@/svg/icons/versioning.svg';
import WandSVG from '@/svg/icons/wand.svg';
import WatchSVG from '@/svg/icons/watch.svg';
import WebhooksSVG from '@/svg/icons/webhooks.svg';
import WrenchSVG from '@/svg/icons/wrench.svg';
import YouTubeSVG from '@/svg/icons/youtube.svg';
import GitHubSVG from '@/svg/icons/github.svg';

export default function Icon({ className, icon, size = 'regular' }) {
  const sizeClass = (sizeParam) => {
    switch (sizeParam) {
      case 'large':
        return 'md:h-16 md:w-16 h-10 w-10';
      case 'medium':
        return 'h-5 w-5';
      case 'small':
        return 'h-4 w-4';
      case 'regular':
      default:
        return 'h-8 w-8';
    }
  };

  switch (icon) {
    case 'AIRPLANE':
      return <AirplaneSVG className={classnames(sizeClass(size), className)} />;
    case 'APIS':
      return <APIsSVG className={classnames(sizeClass(size), className)} />;
    case 'APOLLO':
      return <ApolloSVG className={classnames(sizeClass(size), className)} />;
    case 'ARCHIVE':
      return <ArchiveSVG className={classnames(sizeClass(size), className)} />;
    case 'ASSET':
      return <AssetSVG className={classnames(sizeClass(size), className)} />;
    case 'BOOK':
      return <BookSVG className={classnames(sizeClass(size), className)} />;
    case 'BOOKMARK':
      return <BookmarkSVG className={classnames(sizeClass(size), className)} />;
    case 'BUILDINGS':
      return (
        <BuildingsSVG className={classnames(sizeClass(size), className)} />
      );
    case 'CALENDAR':
      return <CalendarSVG className={classnames(sizeClass(size), className)} />;
    case 'CART':
      return <CartSVG className={classnames(sizeClass(size), className)} />;
    case 'CHAT':
      return <ChatSVG className={classnames(sizeClass(size), className)} />;
    case 'CLOUD_UPLOAD':
      return (
        <CloudUploadSVG className={classnames(sizeClass(size), className)} />
      );
    case 'CODE':
      return <CodeSVG className={classnames(sizeClass(size), className)} />;
    case 'CONNECT':
      return <ConnectSVG className={classnames(sizeClass(size), className)} />;
    case 'CONTENT':
      return <ContentSVG className={classnames(sizeClass(size), className)} />;
    case 'EDIT':
      return <EditSVG className={classnames(sizeClass(size), className)} />;
    case 'FINGERPRINT':
      return (
        <FingerprintSVG className={classnames(sizeClass(size), className)} />
      );
    case 'GAME_CONTROLLER':
      return (
        <GameControllerSVG className={classnames(sizeClass(size), className)} />
      );
    case 'GATSBY':
      return <GatsbySVG className={classnames(sizeClass(size), className)} />;
    case 'GLOBE':
      return <GlobeSVG className={classnames(sizeClass(size), className)} />;
    case 'GOING_UP':
      return <GoingUpSVG className={classnames(sizeClass(size), className)} />;
    case 'GRAPHCMS':
    default:
      return <GCMSSVG className={classnames(sizeClass(size), className)} />;
    case 'GRAPHQL':
      return <GraphQLSVG className={classnames(sizeClass(size), className)} />;
    case 'GRID':
      return <GridSVG className={classnames(sizeClass(size), className)} />;
    case 'GRIDSOME':
      return <GridsomeSVG className={classnames(sizeClass(size), className)} />;
    case 'GROWTH':
      return <GrowthSVG className={classnames(sizeClass(size), className)} />;
    case 'HUGO':
      return <HugoSVG className={classnames(sizeClass(size), className)} />;
    case 'INCOMPLETE_GRID':
      return (
        <IncompleteGridSVG className={classnames(sizeClass(size), className)} />
      );
    case 'JEKYLL':
      return <JekyllSVG className={classnames(sizeClass(size), className)} />;
    case 'LAPTOP':
      return <LaptopSVG className={classnames(sizeClass(size), className)} />;
    case 'LAYERS':
      return <LayersSVG className={classnames(sizeClass(size), className)} />;
    case 'LIST':
      return <ListSVG className={classnames(sizeClass(size), className)} />;
    case 'LOCALIZATION':
      return (
        <LocalizationSVG className={classnames(sizeClass(size), className)} />
      );
    case 'MONEY':
      return <MoneySVG className={classnames(sizeClass(size), className)} />;
    case 'NEXTJS':
      return <NextSVG className={classnames(sizeClass(size), className)} />;
    case 'NUXTJS':
      return <NuxtSVG className={classnames(sizeClass(size), className)} />;
    case 'OMNICHANNEL':
      return (
        <OmnichannelSVG className={classnames(sizeClass(size), className)} />
      );
    case 'PADLOCK':
      return <PadlockSVG className={classnames(sizeClass(size), className)} />;
    case 'PERSON':
      return <PersonSVG className={classnames(sizeClass(size), className)} />;
    case 'PHONE':
      return <PhoneSVG className={classnames(sizeClass(size), className)} />;
    case 'PRIVACY':
      return <PrivacySVG className={classnames(sizeClass(size), className)} />;
    case 'QUESTION':
      return <QuestionSVG className={classnames(sizeClass(size), className)} />;
    case 'REACT':
      return <ReactSVG className={classnames(sizeClass(size), className)} />;
    case 'RESIZE':
      return <ResizeSVG className={classnames(sizeClass(size), className)} />;
    case 'RESIZE_ALL':
      return (
        <ResizeAllSVG className={classnames(sizeClass(size), className)} />
      );
    case 'SVELTE':
      return <SvelteSVG className={classnames(sizeClass(size), className)} />;
    case 'SHARE':
      return <ShareSVG className={classnames(sizeClass(size), className)} />;
    case 'SHEETS':
      return <SheetsSVG className={classnames(sizeClass(size), className)} />;
    case 'SHOPPING':
      return <ShoppingSVG className={classnames(sizeClass(size), className)} />;
    case 'SITEPOINT':
      return (
        <SitepointSVG className={classnames(sizeClass(size), className)} />
      );
    case 'SLACK':
      return <SlackSVG className={classnames(sizeClass(size), className)} />;
    case 'SPEECH':
      return <SpeechSVG className={classnames(sizeClass(size), className)} />;
    case 'SQUARE_PLUS':
      return (
        <SquarePlusSVG className={classnames(sizeClass(size), className)} />
      );
    case 'SQUARE_WRENCH':
      return (
        <SquareWrenchSVG className={classnames(sizeClass(size), className)} />
      );
    case 'STAGING':
      return <StagingSVG className={classnames(sizeClass(size), className)} />;
    case 'STAR':
      return <StarSVG className={classnames(sizeClass(size), className)} />;
    case 'STAR_OUTLINE':
      return (
        <StarOutlineSVG className={classnames(sizeClass(size), className)} />
      );
    case 'TEXTBOX':
      return <TextboxSVG className={classnames(sizeClass(size), className)} />;
    case 'TUNING':
      return <TuningSVG className={classnames(sizeClass(size), className)} />;
    case 'TYPING_CURSOR':
      return (
        <TypingCursorSVG className={classnames(sizeClass(size), className)} />
      );
    case 'USER_SHIELD':
      return (
        <UserShieldSVG className={classnames(sizeClass(size), className)} />
      );
    case 'VERSIONING':
      return (
        <VersioningSVG className={classnames(sizeClass(size), className)} />
      );
    case 'WAND':
      return <WandSVG className={classnames(sizeClass(size), className)} />;
    case 'WATCH':
      return <WatchSVG className={classnames(sizeClass(size), className)} />;
    case 'WEBHOOKS':
      return <WebhooksSVG className={classnames(sizeClass(size), className)} />;
    case 'WRENCH':
      return <WrenchSVG className={classnames(sizeClass(size), className)} />;
    case 'YOUTUBE':
      return <YouTubeSVG className={classnames(sizeClass(size), className)} />;
    case 'GITHUB':
      return <GitHubSVG className={classnames(sizeClass(size), className)} />;
  }
}
